export default [
  { languageName: "Română", languageCode: "ro", isDefault: true },
  { languageName: "English", languageCode: "en" }
];
